import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { reducers } from '@appStore/configuration/reducers';
import { ConfigurationEffectsModule } from '@appStore/configuration/effects';
import * as fromServices from '@appStore/configuration/services';

export * from '@appStore/configuration/reducers';
export * from '@appStore/configuration/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('configuration', reducers), ConfigurationEffectsModule],
  providers: [...fromServices.services]
})
export class ConfigurationModule {}
